<script setup>
import { set, useConsent, consentGrantedAll, addGtag } from "vue-gtag";
const { rejectAll } = useConsent();

import { storeToRefs } from 'pinia';
import { useGlobalStore, useAuthStore } from '@/stores';

const authStore = useAuthStore();
const { user } = storeToRefs(authStore);

const globalStore = useGlobalStore();
const { isCookiesDefined } = storeToRefs(globalStore);
const rejectAllCookies = () => {
    globalStore.triggerCookiesDefined();
    rejectAll();
}
const acceptAllCookies = async () => {
    globalStore.triggerCookiesDefined();
    await addGtag();
    consentGrantedAll();
    set({
        'user_type': user.value?.tipo||'guest',
    });
    window.location.reload();
}
</script>

<template>
  <div v-if="!isCookiesDefined" class="fixed bottom-2 right-2 w-[90vw] max-w-lg z-50 p-4 bg-blue-900 text-white shadow-md">
    <p class="">Este site utiliza cookies para garantir que você tenha a melhor experiência. Ao continuar navegando, você concorda com nosso uso de cookies.</p>

    <button @click="acceptAllCookies" class="btn primary">Aceitar todos</button>
    <button @click="rejectAllCookies" class="btn secondary">Rejeitar todos</button>
  </div>
</template>